import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
const faqs = [{
  q: "¿Cómo recibo el material?",
  a: "Al completar tu compra recibirás un correo electrónico con acceso inmediato para descargar todos los archivos."
}, {
  q: "¿Funciona con cualquier marca de alineadores?",
  a: "Sí. Los protocolos están basados en principios clínicos aplicables a cualquier sistema de alineadores."
}, {
  q: "¿Necesito instalar algún programa?",
  a: "No. Todo el material se entrega en formato PDF de alta calidad y puede consultarse desde computadora, tablet o teléfono."
}, {
  q: "¿El acceso tiene vencimiento?",
  a: "No. El acceso es de por vida."
}, {
  q: "¿Es un pago mensual?",
  a: "No. Pagas una sola vez. No existen renovaciones automáticas."
}, {
  q: "¿También sirve para odontólogos generales?",
  a: "Sí. Está pensado para cualquier profesional que planifique y trate casos con alineadores."
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-navy-50 px-5 py-12" data-id="element-59" data-mp="ugis6su1b95o">
      <div className="mx-auto max-w-md" data-id="element-60" data-mp="fk0d2witc51a">
        <h2 className="text-center font-display text-2xl font-extrabold text-navy-800 sm:text-3xl" data-id="element-61" data-mp="fiytu4rn8c8h">
          Preguntas Frecuentes
        </h2>

        <div className="mt-6 space-y-3" data-id="element-62" data-mp="6rgdntup5wfe">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl border border-navy-100 bg-white" data-id="element-63" data-mp="bj83u39xy050" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left" data-id="element-64" data-mp="3szpnuiw1htkp">
                  <span className="font-display text-sm font-bold text-navy-800" data-id="element-65" data-mp="3k0cctls9owxv">{f.q}</span>
                  <motion.span animate={{
                rotate: isOpen ? 180 : 0
              }} className="shrink-0 text-brand" data-id="element-66" data-mp="3o1o4dwupbs8p">
                    <ChevronDownIcon className="h-5 w-5" data-id="element-67" data-mp="1uixiwy47913q" />
                  </motion.span>
                </button>
                <AnimatePresence initial={false} data-id="element-68" data-mp="1kr1cmzrym4of">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} data-id="element-69" data-mp="1koyjw7zf9xg0">
                      <p className="px-4 pb-4 text-sm leading-relaxed text-navy-800/65" data-id="element-70" data-mp="28hf3wo2pzzhy">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}